import {Component, ElementRef, EventEmitter, Output, ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DragDropModule} from '../../directives/drag-drop-directive/drag-drop.module';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-file-upload-dnd',
  templateUrl: './file-upload-dnd.component.html',
  styleUrl: './file-upload-dnd.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    DragDropModule,
  ]
})
export class FileUploadDndComponent{
  @Output() filesUploaded = new EventEmitter<any[]>();
  @ViewChild("fileDropRef", { static: false }) fileDropEl: ElementRef | undefined;

  MAX_FILE_SIZE = 3145728;
  file: any;
  files: any[] = [];


  constructor(private _snackBar: MatSnackBar) {}

  onFileDropped($event: any){
    this.prepareFilesList($event);
  }

  fileBrowseHandler(files: any) {

    const input = files.target as HTMLInputElement;
    this.prepareFilesList(files.target.files);
    input.value = '';

  }

  deleteFile(index: number) {
    this.files.splice(index, 1);
  }

  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      if (this.files.some(file => file.name === item.name)) {
        this.openSnackBar("Erreur : Un fichier avec le même nom existe déjà");
        continue;
      }
      if (item.size > this.MAX_FILE_SIZE) {
        this.openSnackBar("Erreur : La taille du fichier doit être inférieure à 10Mo");
      } else {
        item.progress = 0;
        this.files.push(item);
      }
    }
    this.filesUploaded.emit(this.files);
    //this.fileDropEl!.nativeElement.value = "";
  }

  formatBytes(bytes: number, decimals: number = 2): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  fileSubmitted(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const files = input.files;
      if (files.length === 1) {
        if (files[0].size > 1048576 * 10) {
          this.openSnackBar(
            "Erreur : La taille du fichier doit être inférieure à 3Mo"
          );
        } else if (
          !["application/pdf", "image/jpeg", "image/png"].includes(files[0].type)
        ) {
          this.openSnackBar(
            "Format du fichier invalide: Veuillez fournir un fichier au format: pdf/jpeg/png"
          );
        } else {
          this.file = files[0];
        }
      }
    }
  }

  openSnackBar(message: string) {
    this._snackBar.open(message, "Fermer", {
      duration: 5000,
    });
  }

  download(index: number): void {
    const file = this.files[index];
    const url = URL.createObjectURL(file);
    const a = document.createElement('a');
    a.href = url;
    a.download = file.name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
}
